var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInspectionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.434,
    height: 20,
    viewBox: "0 0 11.434 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-back",
    "data-name": "Icon ionic-ios-arrow-back",
    d: "M14.7,16.191,22.265,8.63a1.429,1.429,0,0,0-2.024-2.018l-8.574,8.568a1.426,1.426,0,0,0-.042,1.971l8.609,8.627a1.429,1.429,0,0,0,2.024-2.018Z",
    transform: "translate(-11.251 -6.194)",
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectionArrow);
export default __webpack_public_path__ + "static/media/inspection-arrow.b418db2f9f7b0c4a4cfde688a481fc80.svg";
export { ForwardRef as ReactComponent };